const WhyKidsLoveBooq = () => {
  return (
    <section className="why-kids-love-container">
      <div className=" m-auto why-kids-love">
        <h2>Why Kids Love Booq</h2>
        <div className="why-kids-love-grid">
          <div className="why-kids-love-item">
            <b>01.</b>
            <p>
              Bring you own book or choose from a selection of short articles
            </p>
          </div>
          <div className="why-kids-love-item">
            <b>02.</b>
            <p>Take a quiz to earn points and unlock rewards</p>
          </div>
          <div className="why-kids-love-item">
            <b>03.</b>
            <p>Join hundreds of other peers on their reading journey</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyKidsLoveBooq;
